require('./stylesheet/rates.scss');

angular.module('pages.rates', ['ngTouch'])
    .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider
        .state('pages.rates', {
            url: 'rates',
            template: require('./templates/index.html'),
            controller: require('./controllers/rates'),
            data: {
                iframe: false
            },
            pageTrack: '/rates',
            resolve: {
                test: function($translate) {
                    // return $translate('MAIN.REGISTRATION');
                }
            }
        });
}

module.exports = 'pages.rates';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/rates/index.js
 ** module id = 283
 ** module chunks = 1
 **/